export default function useParams (): [string, string] {
    const isns = window.location.pathname.slice(1).split('/') as  [string, string]
    return isns
}